import apiFetch from '../apiFetch'

export default function (device, token) {
  return apiFetch({ endPoint: 'IdocMobile/updateDeviceInstallation', method: 'PUT', body: device, token: token })
}
